import { Heart, MapPin, User } from "lucide-react";
import { EmptyState } from "../../components/shared/EmptyState";

export default function ClientProfilePage() {
  return (
    <div data-testid="client-profile-page">
      <div className="mt-6 grid gap-6 lg:grid-cols-2">
        <div className="card-ae p-6" data-testid="profile-personal">
          <h3 className="flex items-center gap-2 font-heading text-lg text-deepgreen"><User className="h-5 w-5 text-sage" /> Informations personnelles</h3>
          <div className="mt-4 grid gap-4 sm:grid-cols-2">
            <div><label className="label-ae" htmlFor="p-prenom">Prénom</label><input id="p-prenom" className="input-ae" defaultValue="Prénom TEST" data-testid="profile-firstname" /></div>
            <div><label className="label-ae" htmlFor="p-nom">Nom</label><input id="p-nom" className="input-ae" defaultValue="Nom TEST" data-testid="profile-lastname" /></div>
            <div><label className="label-ae" htmlFor="p-email">E-mail</label><input id="p-email" className="input-ae" defaultValue="test@example.fr" data-testid="profile-email" /></div>
            <div><label className="label-ae" htmlFor="p-tel">Téléphone</label><input id="p-tel" className="input-ae" data-testid="profile-phone" /></div>
          </div>
          <p className="mt-3 text-xs text-muted-foreground">Un changement d'e-mail nécessitera la vérification de la nouvelle adresse.</p>
        </div>
        <div className="card-ae p-6" data-testid="profile-addresses">
          <h3 className="flex items-center gap-2 font-heading text-lg text-deepgreen"><MapPin className="h-5 w-5 text-sage" /> Adresses</h3>
          <p className="mt-2 text-sm text-muted-foreground">Votre adresse postale est distincte du lieu de réception de vos événements.</p>
          <div className="mt-4 space-y-3">
            <input className="input-ae" placeholder="Adresse postale" data-testid="profile-address" />
            <div className="grid gap-3 sm:grid-cols-2">
              <input className="input-ae" placeholder="Code postal" data-testid="profile-zip" />
              <input className="input-ae" placeholder="Ville" data-testid="profile-city" />
            </div>
          </div>
        </div>
      </div>
      <div className="mt-6 card-ae p-6" data-testid="profile-favorites">
        <h3 className="flex items-center gap-2 font-heading text-lg text-deepgreen"><Heart className="h-5 w-5 text-sage" /> Favoris &amp; sélections sauvegardées</h3>
        <div className="mt-4">
          <EmptyState title="Aucun favori enregistré">Ajoutez des articles à vos favoris depuis la boutique pour les retrouver ici.</EmptyState>
        </div>
      </div>
    </div>
  );
}
